import { Variant } from '../types/product';
import { WizardState } from '../types/WigWizard';
import axios from 'axios'

export async function addToCart(selectedVariant: Variant, state: WizardState): Promise<any> {
  const selectors = {
    variantQuantity: '[data-variant-quantity]',
  }

  const quantityJSON = JSON.parse(document.querySelector(selectors.variantQuantity)?.innerHTML || '{}')
 
  return axios.post('/cart/add.js', {
    id: selectedVariant.id,
    properties: {
      _In_Stock: (quantityJSON[selectedVariant.id] > 0).toString(),
      Cut: state.Cut,
      Part_Style: state.Part_Style,
      _Cap_Size: state.capSize,
      _Lace_Tint_Hex: state.laceTint,
      Lace_Tint_Description: state.laceTintDescription,
      _s3_bucket_folder: state.s3BucketFolder,
      Adhesive: state.Adhesive,
      Hair_Styling:state.Hair_Styling,
      Prep: state.Prep,
      Bang: state.Bang,
      _sku_image:state.frontImage,
      _shade: state.SkinTone
    }
  })
}
